module.exports = __webpack_public_path__ + "img/127ne.9cb3f06f.svg";